import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store/useAuthStore';
import { BrandedLoader } from '../ui/BrandedLoader';

export function AuthGuard() {
  const isInitialized = useAuthStore((s) => s.isInitialized);
  const identityResolved = useAuthStore((s) => s.identityResolved);
  const session = useAuthStore((s) => s.session);
  const collaborator = useAuthStore((s) => s.collaborator);
  const clientUser = useAuthStore((s) => s.clientUser);
  const location = useLocation();

  if (!isInitialized) {
    return <BrandedLoader />;
  }

  if (!session) {
    return (
      <Navigate to="/login" replace state={{ from: location }} />
    );
  }

  // Session présente mais identité (collaborator/client) pas encore résolue :
  // on attend le fetch pour ne pas flasher "Compte non configuré".
  if (!identityResolved) {
    return <BrandedLoader />;
  }

  // Un client connecté qui atterrit sur une route cabinet → portail.
  if (!collaborator && clientUser) {
    return <Navigate to="/portail" replace />;
  }

  if (!collaborator) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cime-bg">
        <div className="max-w-md w-full p-8 text-center bg-cime-surface rounded-cime border border-neutral-200 shadow-sm">
          <p className="text-lg font-semibold text-neutral-900 mb-2">
            Compte non configuré
          </p>
          <p className="text-sm text-neutral-600">
            Votre compte n&apos;est pas encore lié à un profil collaborateur.
            Contactez votre administrateur.
          </p>
        </div>
      </div>
    );
  }

  return <Outlet />;
}
